<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-11-16 11:27:04
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-10-17 09:25:32
 * @Description: file content
 * @FilePath: \gfmis-card-ppt\src\App.vue
-->
<template>
  <div class="app-root">
    <router-view></router-view>
  </div>
</template>

<script>
import Api from '@/api/publicInfo'
import XEUtils from 'xe-utils';

export default {
  data() {
    return {

    };
  },
  mounted() {
    this.getViewcount();
  },
  methods: {
    // 获取访问量
    async getViewcount() {
      const { data: res } = await Api.getOnlineCount();
      if (res.code !== 200 && res.code !== 0) {
        return this.$message.error(res.msg)
      }
      await this.$store.commit('setViewCount', res.data)
    }
  }
};
</script>
<style lang="scss">
.el-tooltip__popper {
  max-width: 500px;
}

.app-root {
  height: 100%;
  background-color: #f5f5f5;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 1px;
  background-color: white;
}

::-webkit-scrollbar-thumb {
  width: 1px;
  background-color: white;
  border-radius: 6px;
}

.pageRoot {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #f5f5f5;
}

// 分页处理
.el-pager {


  .el-icon-more {
    display: none;
  }

  .number {
    display: none;
  }

  .number.active {
    display: inline-block !important;
  }


}

.el-pagination__jump {
  margin-left: 5px !important;
}
</style>